import { render } from "./ForgotPassword.vue?vue&type=template&id=a0b28de6"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=a0b28de6&lang=css"
script.render = render

export default script